import { Grid, Typography } from '@mui/material';
import {
    getUserWalletName,
    getUserWalletOrSystemWalletName,
} from 'components/contracts-page-wrapper/contracts-page-wrapper-helper';
import { themeObject } from 'lib';

export interface DisplayItem {
    label: string;
    value: any;
    isCode?: boolean;
}

export interface ContractsReceiptWrapperProps {
    chain: string;
    breadCrumType: 'Consent_Contract' | 'Smart_Contract';
    onBackArrowClick: () => void;
    informationDisplayItems: DisplayItem[];
    headerDisplayItems: DisplayItem[];
}

export const viewReceiptsStyles = {
    mainContainerStyles: {
        display: 'flex',
        flexDirection: 'column',
    },
    headingTextStyles: {
        ...themeObject.typography.h2,
        fontSize: '26px',
        lineHeight: '30.52px',
        color: themeObject.palette.primary[700],
    },
    informationTextContainer: {
        mt: '2px',
        mb: '12px',
    },
    headerTextContainer: {
        mt: '24px',
        mb: '12px',
    },
    infoContainerStyles: {
        backgroundColor: themeObject.palette.background.default,
        borderRadius: '10px',
        border: `1px solid ${themeObject.palette.grayScale[300]}`,
        p: '20px 29px 38px 28px',
    },
    headerContainerStyles: {
        backgroundColor: themeObject.palette.background.default,
        borderRadius: '10px',
        border: `1px solid ${themeObject.palette.grayScale[300]}`,
        p: '13px 29px 27px 30px',
        mb: '37px',
    },
    labelAndValueContainerStyles: {
        mt: 2,
    },
    labelTextStyles: {
        ...themeObject.typography.Components.inputLabel,
        lineHeight: '21.17px',
        letterSpacing: '0.15px',
        color: themeObject.palette.grayScale[800],
        mb: '0px',
    },
    valueTextStyles: {
        ...themeObject.typography.Components.inputText,
        lineHeight: '24px',
        color: themeObject.palette.grayScale[800],
        mt: '4px',
        wordBreak: 'break-word',
    },
    codeContainer: {
        borderRadius: '4px',
        backgroundColor: themeObject.palette.grayScale[900],
        p: 3,
        fontFamily: 'Red Hat Mono',
        fontWeight: 400,
        fontSize: '16px',
        lineHeight: '21.17px',
        color: themeObject.palette.grayScale[100],
        mt: '4px',
    },
};

export const LabelAndValueContainer = ({
    label,
    value,
}: {
    label: string;
    value: string;
}): React.JSX.Element => {
    return (
        <Grid sx={viewReceiptsStyles.labelAndValueContainerStyles}>
            <Typography sx={viewReceiptsStyles.labelTextStyles}>
                {label}
            </Typography>
            <Typography sx={viewReceiptsStyles.valueTextStyles}>
                {value ?? '--'}
            </Typography>
        </Grid>
    );
};

export const LabelAndCodeContainer = ({
    label,
    code,
}: {
    label: string;
    code: any;
}): React.JSX.Element => {
    return (
        <Grid sx={viewReceiptsStyles.labelAndValueContainerStyles}>
            <Typography sx={viewReceiptsStyles.labelTextStyles}>
                {label}
            </Typography>
            {code ? (
                <Grid sx={viewReceiptsStyles.codeContainer}>{code}</Grid>
            ) : (
                <Typography sx={viewReceiptsStyles.valueTextStyles}>
                    {'--'}
                </Typography>
            )}
        </Grid>
    );
};

export const getContractOwnerIdOrEffectiveIdName = (
    wallets: any,
    id: string | undefined
): string => {
    return getUserWalletOrSystemWalletName(
        wallets?.data?.userWallets ?? [],
        wallets?.data?.systemWallets ?? [],
        id
    );
};

export const getLoggedInIdName = (
    wallets: any,
    id: string | undefined
): string => {
    return getUserWalletName(wallets?.data?.userWallets ?? [], id);
};
